import * as React from "react";
import { W as WhatsappIcon } from "../legacy/assets/travel-logo-dark-BGbQ8wfq.js";
import LogoLight from "../legacy/assets/travel-logo-light-CTrjYqKI.svg";
import GDLogo from "../legacy/assets/gdbrandcreative-logo-ELm9x73U.svg";
const footerLogoStyle = { filter: "brightness(0) invert(1)" };
const footerGDLogoStyle = undefined;

// ─── Data ─────────────────────────────────────────────────────────────────────

const MONTHLY_GETAWAYS_H1 = [
  { label: "January Getaways", href: "https://travel.rethinkways.com/travel-in-january-travelrethink-ways/" },
  { label: "February Getaways", href: "https://travel.rethinkways.com/travel-in-february-travel-rethink-ways/" },
  { label: "March Getaways", href: "https://travel.rethinkways.com/vacation-in-march-travel-rethink-ways/" },
  { label: "April Getaways", href: "https://travel.rethinkways.com/visit-in-april-travelrethink-ways/" },
  { label: "May Getaways", href: "https://travel.rethinkways.com/visit-in-may-travel-rethink-ways/" },
  { label: "June Getaways", href: "https://travel.rethinkways.com/travel-in-june-travel-rethink-ways/" },
];

const MONTHLY_GETAWAYS_H2 = [
  { label: "July Getaways", href: "https://travel.rethinkways.com/travel-in-july/" },
  { label: "August Getaways", href: "https://travel.rethinkways.com/visit-in-august/" },
  { label: "September Getaways", href: "https://travel.rethinkways.com/travel-in-september/" },
  { label: "October Getaways", href: "https://travel.rethinkways.com/travel-in-october/" },
  { label: "November Getaways", href: "https://travel.rethinkways.com/visit-in-november/" },
  { label: "December Getaways", href: "https://travel.rethinkways.com/international-visit-in-december/" },
];

const INDIA_PLACES_H1 = [
  { label: "Places to Visit in January", href: "https://travel.rethinkways.com/30-best-places-to-visit-in-january-in-india/" },
  { label: "Places to Visit in February", href: "https://travel.rethinkways.com/places-to-visit-in-february-2026-in-india/" },
  { label: "Places to Visit in March", href: "https://travel.rethinkways.com/places-to-visit-in-india-in-march-2026/" },
  { label: "Places to Visit in April", href: "https://travel.rethinkways.com/30-best-places-to-visit-in-india-in-april/" },
  { label: "Places to Visit in May", href: "https://travel.rethinkways.com/best-places-to-visit-in-india-in-may-2026/" },
  { label: "Places to Visit in June", href: "https://travel.rethinkways.com/30-best-places-to-visit-in-india-in-june/" },
];

const INDIA_PLACES_H2 = [
  { label: "Places to Visit in July", href: "https://travel.rethinkways.com/30-best-places-to-visit-in-india-in-july/" },
  { label: "Places to Visit in August", href: "https://travel.rethinkways.com/best-places-to-visit-india-in-august-2026/" },
  { label: "Places to Visit in September", href: "https://travel.rethinkways.com/30-best-places-to-visit-india-in-september/" },
  { label: "Places to Visit in October", href: "https://travel.rethinkways.com/30-best-places-to-visit-in-october-in-india/" },
  { label: "Places to Visit in November", href: "https://travel.rethinkways.com/30-best-places-to-visit-november-in-india/" },
  { label: "Places to Visit in December", href: "https://travel.rethinkways.com/30-best-places-to-visit-india-in-december/" },
];

const VISA_H1 = [
  { label: "Bali", href: "https://travel.rethinkways.com/indonesia-visa-for-indians-2026-guide/" },
  { label: "Barbados", href: "https://travel.rethinkways.com/barbados-visa-for-indians-guide-2026/" },
  { label: "Bhutan", href: "https://travel.rethinkways.com/bhutan-tourist-entry-rules-for-indians-2026/" },
  { label: "Dubai", href: "https://travel.rethinkways.com/dubai-visa-for-indians-2026-guide/" },
  { label: "Georgia", href: "https://travel.rethinkways.com/georgia-visa-for-indians-best-guide-2026/" },
  { label: "Kazakhstan", href: "https://travel.rethinkways.com/kazakhstan-visa-guide-for-indians-2026/" },
  { label: "Kenya", href: "https://travel.rethinkways.com/kenya-visa-for-indians-2026-complete-guide/" },
];

const VISA_H2 = [
  { label: "Malaysia", href: "https://travel.rethinkways.com/malaysia-visa-free-entry-indians-2026-mdac/" },
  { label: "Maldives", href: "https://travel.rethinkways.com/maldives-tourist-visa-for-indian-passport/" },
  { label: "Mauritius", href: "https://travel.rethinkways.com/mauritius-tourist-visa-for-indians-2026/" },
  { label: "Philippines", href: "https://travel.rethinkways.com/philippines-visa-guide-for-indians-2026/" },
  { label: "Schengen Countries", href: "https://travel.rethinkways.com/schengen-visa-2026-complete-guide-indians/" },
  { label: "Sri Lanka", href: "https://travel.rethinkways.com/sri-lanka-tourist-visa-for-indians-2026/" },
  { label: "Thailand", href: "https://travel.rethinkways.com/thailand-visa-free-entry-for-indians-tdac/" },
];

const CURATED_PICKS = [
  { label: "Attractions", href: "https://travel.rethinkways.com/category/attractions/" },
  { label: "Culinary Journey", href: "https://travel.rethinkways.com/category/culinary/" },
  { label: "Family Getaways", href: "https://travel.rethinkways.com/category/family-getaways/" },
  { label: "Friends Trip Suggestion", href: "https://travel.rethinkways.com/category/friends/" },
  { label: "International Honeymoon Destinations", href: "https://travel.rethinkways.com/category/honeymoon-global/" },
  { label: "Unique Stays", href: "https://travel.rethinkways.com/category/unique-stays/" },
  { label: "Weekend Getaways", href: "https://travel.rethinkways.com/category/weekend-getaways/" },
];

const EXPLORE_BY_EXPERIENCE = [
  { label: "Adventure", href: "https://travel.rethinkways.com/category/adventure/" },
  { label: "Beaches", href: "https://travel.rethinkways.com/category/beaches/" },
  { label: "Desert", href: "https://travel.rethinkways.com/category/desert/" },
  { label: "Heritage", href: "https://travel.rethinkways.com/category/heritage/" },
  { label: "Hill Stations", href: "https://travel.rethinkways.com/category/hill-stations/" },
  { label: "Islands", href: "https://travel.rethinkways.com/category/islands/" },
  { label: "Wildlife Experience", href: "https://travel.rethinkways.com/category/wildlife/" },
];

const TOUR_PACKAGES_URLS = {
  india: "https://travel.rethinkways.com/travel-tour-packages/?section=india",
  international: "https://travel.rethinkways.com/tour-packages?section=international",
  europe: "https://travel.rethinkways.com/travel-tour-packages/?section=europe",
};

// Andaman gets its own dedicated page; every other India state keeps the shared section link.
const INDIA_TOUR_PACKAGES = [
  { label: "Andaman Tour Packages", href: "https://travel.rethinkways.com/andaman-tour-packages/" },
  { label: "Andhra Pradesh Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Arunachal Pradesh Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Assam Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Bihar Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Chandigarh Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Chhattisgarh Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Dadra and Nagar Haveli and Daman and Diu Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Delhi Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Goa Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Gujarat Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Haryana Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Himachal Pradesh Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Jammu and Kashmir Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Jharkhand Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Karnataka Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Kerala Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Ladakh Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Lakshadweep Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Madhya Pradesh Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Maharashtra Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Manipur Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Meghalaya Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Mizoram Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Nagaland Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Odisha Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Puducherry Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Punjab Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Rajasthan Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Sikkim Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Tamil Nadu Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Telangana Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Tripura Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Uttar Pradesh Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "Uttarakhand Tour Packages", href: TOUR_PACKAGES_URLS.india },
  { label: "West Bengal Tour Packages", href: TOUR_PACKAGES_URLS.india },
];

// Every international country now points to its own dedicated {country}-tour-packages/ page.
const INTERNATIONAL_TOUR_PACKAGES = [
  { label: "Australia Tour Packages", href: "https://travel.rethinkways.com/australia-tour-packages/" },
  { label: "Bali Tour Packages", href: "https://travel.rethinkways.com/bali-tour-packages/" },
  { label: "Bhutan Tour Packages", href: "https://travel.rethinkways.com/bhutan-tour-packages/" },
  { label: "Cambodia Tour Packages", href: "https://travel.rethinkways.com/cambodia-tour-packages/" },
  { label: "Canada Tour Packages", href: "https://travel.rethinkways.com/canada-tour-packages/" },
  { label: "China Tour Packages", href: "https://travel.rethinkways.com/china-tour-packages/" },
  { label: "Dubai Tour Packages", href: "https://travel.rethinkways.com/dubai-tour-packages/" },
  { label: "Egypt Tour Packages", href: "https://travel.rethinkways.com/egypt-tour-packages/" },
  { label: "Fiji Tour Packages", href: "https://travel.rethinkways.com/fiji-tour-packages/" },
  { label: "Hong Kong Tour Packages", href: "https://travel.rethinkways.com/hong-kong-tour-packages/" },
  { label: "Japan Tour Packages", href: "https://travel.rethinkways.com/japan-tour-packages/" },
  { label: "Jordan Tour Packages", href: "https://travel.rethinkways.com/jordan-tour-packages/" },
  { label: "Kazakhstan Tour Packages", href: "https://travel.rethinkways.com/kazakhstan-tour-packages/" },
  { label: "Kenya Tour Packages", href: "https://travel.rethinkways.com/kenya-tour-packages/" },
  { label: "Laos Tour Packages", href: "https://travel.rethinkways.com/laos-tour-packages/" },
  { label: "Malaysia Tour Packages", href: "https://travel.rethinkways.com/malaysia-tour-packages/" },
  { label: "Maldives Tour Packages", href: "https://travel.rethinkways.com/maldives-tour-packages/" },
  { label: "Mauritius Tour Packages", href: "https://travel.rethinkways.com/mauritius-tour-packages/" },
  { label: "Nepal Tour Packages", href: "https://travel.rethinkways.com/nepal-tour-packages/" },
  { label: "New Zealand Tour Packages", href: "https://travel.rethinkways.com/new-zealand-tour-packages/" },
  { label: "Oman Tour Packages", href: "https://travel.rethinkways.com/oman-tour-packages/" },
  { label: "Philippines Tour Packages", href: "https://travel.rethinkways.com/philippines-tour-packages/" },
  { label: "Qatar Tour Packages", href: "https://travel.rethinkways.com/qatar-tour-packages/" },
  { label: "Seychelles Tour Packages", href: "https://travel.rethinkways.com/seychelles-tour-packages/" },
  { label: "Singapore Tour Packages", href: "https://travel.rethinkways.com/singapore-tour-packages/" },
  { label: "South Africa Tour Packages", href: "https://travel.rethinkways.com/south-africa-tour-packages/" },
  { label: "South Korea Tour Packages", href: "https://travel.rethinkways.com/south-korea-tour-packages/" },
  { label: "Sri Lanka Tour Packages", href: "https://travel.rethinkways.com/sri-lanka-tour-packages/" },
  { label: "Tanzania Tour Packages", href: "https://travel.rethinkways.com/tanzania-tour-packages/" },
  { label: "Thailand Tour Packages", href: "https://travel.rethinkways.com/thailand-tour-packages/" },
  { label: "Turkey Tour Packages", href: "https://travel.rethinkways.com/turkey-tour-packages/" },
  { label: "USA Tour Packages", href: "https://travel.rethinkways.com/usa-tour-packages/" },
  { label: "Uzbekistan Tour Packages", href: "https://travel.rethinkways.com/uzbekistan-tour-packages/" },
  { label: "Vietnam Tour Packages", href: "https://travel.rethinkways.com/vietnam-tour-packages/" },
];

// Europe left untouched — same shared section link as before.
const EUROPE_TOUR_PACKAGES = ([
  { label: "Albania Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Armenia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Austria Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Azerbaijan Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Belarus Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Belgium Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Bulgaria Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Croatia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Czech Republic Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Denmark Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Estonia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Europe Multi-Country Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Finland Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "France Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Georgia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Germany Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Greece Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Hungary Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Iceland Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Ireland Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Italy Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Latvia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Liechtenstein Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Lithuania Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Luxembourg Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Malta Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Montenegro Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Netherlands Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "North Macedonia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Norway Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Poland Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Portugal Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Romania Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Russia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "San Marino Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Serbia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Slovakia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Slovenia Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Spain Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Sweden Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Switzerland Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Turkey Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "United Kingdom Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
  { label: "Vatican City Tour Packages", href: "https://travel.rethinkways.com/travel-tour-packages/" },
]).map((item) => ({ ...item, href: TOUR_PACKAGES_URLS.europe }));

const TRW_LINKS = [
  { label: "About Us", href: "https://travel.rethinkways.com/about-us-travel-rethink-ways/" },
  { label: "Advertise With Us", href: "https://travel.rethinkways.com/advertise-with-us/" },
  { label: "Brand Story", href: "https://travel.rethinkways.com/category/brand-story/" },
  { label: "Careers", href: "https://travel.rethinkways.com/jobs" },
  { label: "Contact Us", href: "https://travel.rethinkways.com/contact-us/" },
];

const LEGAL_LINKS = [
  { label: "Terms & Conditions", href: "https://travel.rethinkways.com/terms-and-conditions/" },
  { label: "Privacy Policy", href: "https://travel.rethinkways.com/privacy-policy/" },
  { label: "Cookies Policy", href: "https://travel.rethinkways.com/cookies-policy" },
  { label: "Disclaimer", href: "https://travel.rethinkways.com/disclaimer-travel-rethink-ways/" },
  { label: "Affiliate Disclosure", href: "https://travel.rethinkways.com/affiliate-disclosure/" },
  { label: "Sitemap", href: "https://travel.rethinkways.com/sitemap_index.xml" },
];

const SOCIAL_LINKS_FOOTER = [
  { label: "WhatsApp", href: "https://whatsapp.com/channel/0029Vb69sC2JJhzYpd1zRQ1C", icon: "fa-whatsapp" },
  { label: "Instagram", href: "https://instagram.com/travel.rethinkways", icon: "fa-instagram" },
  { label: "Pinterest", href: "https://in.pinterest.com/travelrethinkways/", icon: "fa-pinterest-p" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/travel-rethink-ways/", icon: "fa-linkedin-in" },
  { label: "YouTube", href: "https://www.youtube.com/@Travel.Rethinkways", icon: "fa-youtube" },
];

const SOCIAL_LINKS_BOTTOM = [
  { label: "WhatsApp", href: "https://whatsapp.com/channel/0029Vb69sC2JJhzYpd1zRQ1C", icon: "fa-whatsapp" },
  { label: "Instagram", href: "https://instagram.com/travel.rethinkways", icon: "fa-instagram" },
  { label: "Facebook", href: "https://www.facebook.com/share/1CNm92gSxo/", icon: "fa-facebook-f" },
  { label: "X", href: "https://x.com/rethinkways", icon: "fa-x-twitter" },
  { label: "YouTube", href: "https://www.youtube.com/@Travel.Rethinkways", icon: "fa-youtube" },
  { label: "Threads", href: "https://www.threads.com/@travel.rethinkways", icon: "fa-threads" },
  { label: "Pinterest", href: "https://in.pinterest.com/travelrethinkways/", icon: "fa-pinterest-p" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/travel-rethink-ways/", icon: "fa-linkedin-in" },
];

const CONTACT_LINKS = [
  { key: "phone", mobileLabel: "Phone", label: "+91 8438506813", href: "tel:+918438506813", icon: "fa-phone" },
  { key: "email", mobileLabel: "travel@rethinkways.com", label: "travel@rethinkways.com", href: "mailto:travel@rethinkways.com", icon: "fa-envelope" },
  { key: "location", mobileLabel: "Chennai, Tamil Nadu, India", label: "Chennai, Tamil Nadu, India", href: "https://travel.rethinkways.com/contact-us/", icon: "fa-location-dot" },
];

const GROWTH_OFFERINGS = [
  { label: "Advertise With Us", href: "https://travel.rethinkways.com/advertise-with-us/" },
  { label: "Brand Story", href: "https://travel.rethinkways.com/category/brand-story/" },
  { label: "Super Deals", href: "https://travel.rethinkways.com/super-deals/" },
  { label: "Travel Stories", href: "https://travel.rethinkways.com/travel-web-stories/" },
];

// ─── Constants ────────────────────────────────────────────────────────────────

const DESCRIPTION =
  "Travel Rethink Ways is a modern travel intelligence platform built for today's travelers. We simplify global travel decisions through curated destination insights, practical guides, unique stays, value-driven deals, and trusted recommendations helping you travel with clarity, confidence, and purpose.";

const COPYRIGHT_FULL = "© 2026 Travel Rethink Ways from";
const COPYRIGHT_YEAR = "© 2026";
const BRAND_NAME = "Travel Rethink Ways";
const BRAND_FROM = "from";

const SOCIAL_COLORS = {
  "fa-whatsapp": "text-[#25D366]",
  "fa-instagram": "text-[#E1306C]",
  "fa-facebook-f": "text-[#1877F2]",
  "fa-x-twitter": "text-white",
  "fa-youtube": "text-[#FF0000]",
  "fa-threads": "text-white",
  "fa-pinterest-p": "text-[#E60023]",
  "fa-linkedin-in": "text-[#0A66C2]",
};

// ─── Sub-components ───────────────────────────────────────────────────────────

function FooterLinkList({ items, className = "text-sm" }) {
  return (
    <ul className={`space-y-2 ${className}`}>
      {items.map((item) => (
        <li key={item.label}>
          <a
            href={item.href}
            target="_self"
            rel="noopener noreferrer"
            className={`text-white/95 hover:text-[#cccccc] ${
              item.label === "Advertise With Us" ? "hover:text-[#D02525]" : ""
            }`}
          >
            {item.label}
          </a>
        </li>
      ))}
    </ul>
  );
}

function FooterHeading({ children }) {
  return (
    <h3 className="mb-4 text-[18px] font-bold text-white font-poppins">{children}</h3>
  );
}

// ─── Footer Component ─────────────────────────────────────────────────────────

export function Footer() {
  const [openSection, setOpenSection] = React.useState(null);

  const trwLinksFiltered = TRW_LINKS.filter(
    (l) => l.label !== "Advertise With Us" && l.label !== "Brand Story"
  );

  const mobileSections = [
    { key: "growth", title: "Growth Offerings", items: GROWTH_OFFERINGS },
    { key: "monthly", title: "International Monthly Getaways", items: [...MONTHLY_GETAWAYS_H1, ...MONTHLY_GETAWAYS_H2] },
    { key: "india", title: "Experience India 2026", items: [...INDIA_PLACES_H1, ...INDIA_PLACES_H2] },
    { key: "visa", title: "VISA Process", items: [...VISA_H1, ...VISA_H2] },
    { key: "curated", title: "Curated Travel Picks", items: CURATED_PICKS },
    { key: "explore", title: "Explore By Experience", items: EXPLORE_BY_EXPERIENCE },
    { key: "india-tour", title: "India Tour Package", items: INDIA_TOUR_PACKAGES },
    { key: "international-tour", title: "International Tour Packages", items: INTERNATIONAL_TOUR_PACKAGES },
    { key: "europe-tour", title: "Europe Tour Packages", items: EUROPE_TOUR_PACKAGES },
    { key: "trw", title: "Travel Rethink Ways", items: TRW_LINKS },
    { key: "legal", title: "Legal", items: LEGAL_LINKS },
    { key: "touch", title: "Get In Touch", items: CONTACT_LINKS.map((c) => ({ label: c.mobileLabel || c.label, href: c.href })) },
    { key: "social", title: "Social", items: SOCIAL_LINKS_FOOTER },
  ];

  const toggleSection = (key) => {
    setOpenSection((prev) => (prev === key ? null : key));
  };

  return (
    <footer className="trw-footer mt-12 bg-black text-white [font-family:Poppins,sans-serif]">

      {/* ── Mobile Footer (below 1101px) ── */}
      <div className="mx-auto max-w-[1500px] px-4 py-8 text-[18px] min-[1101px]:hidden lg:px-[20px]">

        {/* Logo */}
        <div className="mb-5 flex justify-center">
          <img src={LogoLight} alt="Travel Rethink Ways" className="h-auto w-[180px]" style={footerLogoStyle} />
        </div>

        {/* Description */}
        <p className="mb-6 text-center text-[18px] leading-[1.55] text-white">{DESCRIPTION}</p>

        {/* Accordion */}
        <div className="border-t border-[#1a1a1a]">
          {mobileSections.map((section) => {
            const isOpen = openSection === section.key;
            return (
              <div key={section.key} className="border-b border-[#1a1a1a]">
                <button
                  type="button"
                  onClick={() => toggleSection(section.key)}
                  className="flex w-full items-center justify-between py-4 text-left"
                >
                  <span className="text-[18px] font-[700] leading-none">{section.title}</span>
                  <span className="text-[18px] font-[700] leading-none">{isOpen ? "-" : "+"}</span>
                </button>

                {isOpen && (
                  <ul className="pb-4">
                    {section.items.map((item) => (
                      <li key={`${section.key}-${item.label}`} className="py-1.5">
                        <a
                          href={item.href}
                          target="_self"
                          rel="noopener noreferrer"
                          className={`inline-flex items-center gap-2 text-[14px] text-white/90 ${
                            item.label === "Advertise With Us" ? "hover:text-[#D02525]" : ""
                          }`}
                        >
                          {section.key === "social" && item.icon ? (
                            item.icon === "fa-whatsapp" ? (
                              <WhatsappIcon className="text-[16px]" />
                            ) : (
                              <i className={`fa-brands ${item.icon} text-[16px]`} />
                            )
                          ) : null}
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>

        {/* Mobile bottom bar */}
        <div className="mt-5 pt-4 text-center">
          <div className="flex items-center justify-center gap-4 mb-3">
            {SOCIAL_LINKS_BOTTOM.map((social) => (
              <a
                key={`mobile-bottom-${social.label}`}
                href={social.href}
                target="_self"
                rel="noopener noreferrer"
                aria-label={social.label}
              >
                {social.icon === "fa-whatsapp" ? (
                  <WhatsappIcon className="text-[20px] text-[#25D366]" />
                ) : (
                  <i className={`fa-brands ${social.icon} text-[20px] ${SOCIAL_COLORS[social.icon] || "text-white"}`} />
                )}
              </a>
            ))}
          </div>
          <div className="flex items-center justify-center gap-2 text-[11px] text-white">
            <span>{COPYRIGHT_FULL}</span>
            <a href="https://gdbrandcreative.com/" target="_self" rel="noopener noreferrer">
              <img src={GDLogo} alt="GD Brand Creative" width={120} height={28} className="h-7 w-auto" style={footerGDLogoStyle} loading="lazy" decoding="async" />
            </a>
          </div>
        </div>
      </div>

      {/* ── Desktop Footer (1101px and above) ── */}
      <div className="mx-auto hidden max-w-[1500px] px-4 py-14 min-[1101px]:block lg:px-[20px]">

        {/* Row 1: Logo + Description + Growth Offerings */}
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-4 lg:items-start lg:gap-x-16">
          <div className="flex justify-center lg:justify-start">
            <img
              src={LogoLight}
              alt="Travel Rethink Ways"
              width={300}
              height={80}
              className="h-auto w-[220px] md:w-[300px]"
              style={footerLogoStyle}
              loading="lazy"
              decoding="async"
            />
          </div>

          <p className="max-w-[620px] text-[19px] leading-relaxed font-[300] text-white/95 lg:col-span-2 lg:pt-2">
            {DESCRIPTION}
          </p>

          {/* Growth Offerings — text-sm to match all other FooterLinkList columns */}
          <section className="text-center lg:pt-2 lg:text-left">
            <FooterHeading>Growth Offerings</FooterHeading>
            <FooterLinkList items={GROWTH_OFFERINGS} className="space-y-2 text-sm" />
          </section>
        </div>

        <div className="my-10 h-px bg-[#292929]" />

        {/* Row 2: Monthly Getaways + Experience India */}
        <div className="grid grid-cols-1 gap-y-10 lg:grid-cols-4 lg:gap-x-16">
          <section className="lg:col-span-2">
            <FooterHeading>International Monthly Getaways</FooterHeading>
            <div className="grid grid-cols-1 gap-x-16 gap-y-2 sm:grid-cols-2">
              <FooterLinkList items={MONTHLY_GETAWAYS_H1} />
              <FooterLinkList items={MONTHLY_GETAWAYS_H2} />
            </div>
          </section>

          <section className="lg:col-span-2">
            <FooterHeading>Experience India 2026</FooterHeading>
            <div className="grid grid-cols-1 gap-x-16 gap-y-2 sm:grid-cols-2">
              <FooterLinkList items={INDIA_PLACES_H1} />
              <FooterLinkList items={INDIA_PLACES_H2} />
            </div>
          </section>
        </div>

        <div className="my-10 h-px bg-[#292929]" />

        {/* Row 3: VISA + Curated + Explore */}
        <div className="grid grid-cols-1 gap-y-10 lg:grid-cols-4 lg:gap-x-16">
          <section className="lg:col-span-2">
            <FooterHeading>VISA Process</FooterHeading>
            <div className="grid grid-cols-1 gap-x-16 gap-y-2 sm:grid-cols-2">
              <FooterLinkList items={VISA_H1} />
              <FooterLinkList items={VISA_H2} />
            </div>
          </section>

          <section>
            <FooterHeading>Curated Travel Picks</FooterHeading>
            <FooterLinkList items={CURATED_PICKS} />
          </section>

          <section>
            <FooterHeading>Explore By Experience</FooterHeading>
            <FooterLinkList items={EXPLORE_BY_EXPERIENCE} />
          </section>
        </div>

        <div className="my-10 h-px bg-[#292929]" />

        {/* Row 4: India Tour Packages */}
        <section>
          <FooterHeading>India Tour Package</FooterHeading>
          <div className="grid grid-cols-1 gap-x-12 gap-y-2 sm:grid-cols-2 lg:grid-cols-4">
            <FooterLinkList items={INDIA_TOUR_PACKAGES.slice(0, 9)} />
            <FooterLinkList items={INDIA_TOUR_PACKAGES.slice(9, 18)} />
            <FooterLinkList items={INDIA_TOUR_PACKAGES.slice(18, 27)} />
            <FooterLinkList items={INDIA_TOUR_PACKAGES.slice(27)} />
          </div>
        </section>

        <div className="my-10 h-px bg-[#292929]" />

        {/* Row 5: International Tour Packages */}
        <section>
          <FooterHeading>International Tour Packages</FooterHeading>
          <div className="grid grid-cols-1 gap-x-12 gap-y-2 sm:grid-cols-2 lg:grid-cols-4">
            <FooterLinkList items={INTERNATIONAL_TOUR_PACKAGES.slice(0, 9)} />
            <FooterLinkList items={INTERNATIONAL_TOUR_PACKAGES.slice(9, 18)} />
            <FooterLinkList items={INTERNATIONAL_TOUR_PACKAGES.slice(18, 27)} />
            <FooterLinkList items={INTERNATIONAL_TOUR_PACKAGES.slice(27)} />
          </div>
        </section>

        <div className="my-10 h-px bg-[#292929]" />

        {/* Row 6: Europe Tour Packages */}
        <section>
          <FooterHeading>Europe Tour Packages</FooterHeading>
          <div className="grid grid-cols-1 gap-x-12 gap-y-2 sm:grid-cols-2 lg:grid-cols-4">
            <FooterLinkList items={EUROPE_TOUR_PACKAGES.slice(0, 11)} />
            <FooterLinkList items={EUROPE_TOUR_PACKAGES.slice(11, 22)} />
            <FooterLinkList items={EUROPE_TOUR_PACKAGES.slice(22, 33)} />
            <FooterLinkList items={EUROPE_TOUR_PACKAGES.slice(33)} />
          </div>
        </section>

        <div className="my-10 h-px bg-[#292929]" />

        {/* Row 7: TRW + Legal + Contact + Social */}
        <div className="grid grid-cols-1 gap-y-10 md:grid-cols-2 md:gap-x-12 lg:grid-cols-4 lg:gap-x-16">
          <section>
            <FooterHeading>Travel Rethink Ways</FooterHeading>
            <FooterLinkList items={trwLinksFiltered} />
          </section>

          <section>
            <FooterHeading>Legal</FooterHeading>
            <FooterLinkList items={LEGAL_LINKS} />
          </section>

          <section>
            <FooterHeading>Get In Touch</FooterHeading>
            <ul className="space-y-3 text-sm text-white/95">
              {CONTACT_LINKS.map((contact) => (
                <li key={`desktop-touch-${contact.key}`}>
                  <a href={contact.href} className="hover:text-[#cccccc]">
                    <i className={`fa-solid ${contact.icon} mr-2`} />
                    {contact.label}
                  </a>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <FooterHeading>Social</FooterHeading>
            <ul className="space-y-2 text-sm">
              {SOCIAL_LINKS_FOOTER.map((social) => (
                <li key={social.label}>
                  <a
                    href={social.href}
                    target="_self"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-white/95 hover:text-[#cccccc]"
                  >
                    {social.icon === "fa-whatsapp" ? (
                      <WhatsappIcon className="mr-2 h-[14px] w-[14px] shrink-0" />
                    ) : (
                      <i className={`fa-brands ${social.icon} mr-2 w-[14px] shrink-0 text-center`} />
                    )}
                    {social.label}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </div>

        <div className="my-10 h-px bg-[#292929]" />

        {/* Bottom bar */}
        <div className="grid grid-cols-1 items-center gap-5 py-2 text-center md:grid-cols-[max-content_max-content_max-content] md:justify-between md:gap-6 md:text-left">
          <div className="text-[14px] font-normal text-white [font-family:Poppins,sans-serif]">
            {COPYRIGHT_YEAR}
          </div>

          <div className="flex items-center justify-center gap-2 text-[14px] font-normal text-white [font-family:Poppins,sans-serif] md:text-center">
            <span>{BRAND_NAME}</span>
            <span>{BRAND_FROM}</span>
            <a href="https://gdbrandcreative.com/" target="_self" rel="noopener noreferrer">
              <img src={GDLogo} alt="GD Brand Creative" width={120} height={32} className="h-8 w-auto" style={footerGDLogoStyle} loading="lazy" decoding="async" />
            </a>
          </div>

          <div className="flex items-center justify-center gap-4 md:justify-end">
            {SOCIAL_LINKS_BOTTOM.map((social) => (
              <a
                key={`desktop-bottom-${social.label}`}
                href={social.href}
                target="_self"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="inline-flex h-5 w-5 items-center justify-center"
              >
                {social.icon === "fa-whatsapp" ? (
                  <WhatsappIcon className="text-[16px] text-[#25D366]" />
                ) : (
                  <i className={`fa-brands ${social.icon} text-[16px] ${SOCIAL_COLORS[social.icon] || "text-white"}`} />
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;